// extracted by mini-css-extract-plugin
export var clickCatcher = "clickCatcher-module--clickCatcher--ZvKvi";
export var clickCatcherNoMobile = "clickCatcher-module--clickCatcherNoMobile--nwtN+ clickCatcher-module--clickCatcher--ZvKvi";
export var slideUp = "clickCatcher-module--slideUp--Jgi8K";
export var slideUpLarge = "clickCatcher-module--slideUpLarge--PA2RV";